export const getBusinessCard = state => state.businessCards;
export const getCardSettings = state => state.businessCards.settings;
export const getCardActions = state => state.businessCards.cardActions.actions;
export const getCardImages = state => state.businessCards.images;
export const getCardDeletedActions = state => state.businessCards.cardActions.deletedActions;

export default {getBusinessCard , getCardSettings , getCardActions , getCardImages};